<template lang="pug">
div
  .md-headline Demographics
  gender-radio(v-model='entity.gender')
  md-layout(:md-gutter='24')
    md-layout(md-flex='50', md-flex-small='100')
      age-selector(v-model='entity.ages', :multiple='true')
    md-layout(md-flex='50', md-flex-small='100')
      education-selector(v-model='entity.educations', :multiple='true')
  md-layout(:md-gutter='24')
    md-layout(md-flex='50', md-flex-small='100')
      house-hold-selector(v-model='entity.households', :multiple='true')
    md-layout(md-flex='50', md-flex-small='100')
      income-selector(v-model='entity.incomes', :multiple='true')
</template>

<script>
  import GenderRadio from '../demographic/GenderRadio';
  import HouseHoldSelector from '../demographic/HouseHoldSelector';
  import IncomeSelector from '../demographic/IncomeSelector';
  import AgeSelector from '../demographic/AgeSelector';
  import EducationSelector from '../demographic/EducationSelector';

  export default {
    components: {
      GenderRadio,
      HouseHoldSelector,
      IncomeSelector,
      AgeSelector,
      EducationSelector
    },
    data() {
      return {
      };
    },
    props: {
      entity: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .md-headline {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/DemographicForm.vue